<template>
<div>
  <v-layout v-if="questionType == 'Matching/Dropdown'" row justify-space-between>
    <v-flex xs5>
      <v-text-field
        :label="answer.letter"
        v-model="answer.text"
        class="my-0"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-text-field
        label="Match"
        v-model="answer.correct"
        class="my-0 ml-3"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex class="text-xs-right" xs>
      <v-btn 
        @click="toDelete"
        color="error"
        class="mt-3"
        :disabled="questionType == 'True/False'"
        flat
        icon
        small
      ><v-icon>close</v-icon></v-btn>
    </v-flex>
  </v-layout>

  <v-layout v-else row justify-space-between>
    <v-flex xs>
      <v-checkbox
        @click="setCorrect"
        v-model="answer.correct"
        class="mt-3 ml-1"
        color="primary"
        hide-details
      ></v-checkbox>
    </v-flex>
    <v-flex class="pl-2" xs10 sm11>
      <v-text-field
        :label="answer.letter"
        v-model="answer.text"
        class="my-0"
        :readonly="questionType == 'True/False'"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex class="text-xs-center" xs>
      <v-btn 
        @click="toDelete"
        color="error"
        class="mt-3"
        :disabled="questionType == 'True/False'"
        flat
        icon
        small
      ><v-icon>close</v-icon></v-btn>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
export default {
  props: ['answer', 'questionType'],
  methods: {
    setCorrect () {
      this.$emit('correct')
    },
    toDelete () {
      this.$emit('delete')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questions/AnswerCard.vue